import React from 'react';

interface ChevronDownProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const ChevronDown: React.FC<ChevronDownProps> = ({ width = 12, height = 12, className, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" className={className} style={style}>
      <path
        d="M3 4.5L6 7.5L9 4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronDown;
